import { render, staticRenderFns } from "./page-section.vue?vue&type=template&id=0e51b078&scoped=true&lang=pug"
import script from "./page-section.vue?vue&type=script&lang=ts"
export * from "./page-section.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e51b078",
  null
  
)

export default component.exports